import { SettingValues } from '@linearb/linjs-common';
import { extractSelectedEntitiesFromFilter } from 'common/services/pm.service';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { pmToolSensorIdSelector } from 'state/selectors/sensors-authorizations';
import { DefinitionLevels } from 'common/services/settings.service';
import { generatePmImportPayloadFromEntities } from '../../../../../../services/project-management.service';
import useSettingsService from 'components/hooks/useSettingsService';

const usePmImportStrategyEntity = ({ entityName }) => {
  const { getSettingOrDefinitionValue, updateSetting } = useSettingsService();
  const [selectedEntities, setSelectedEntities] = useState([]);
  const pmToolSensorId = useSelector(pmToolSensorIdSelector);
  const pmImportSetting = getSettingOrDefinitionValue(
    {
      name: SettingValues.PM_IMPORT_STRATEGY,
      definitionLevel: DefinitionLevels.ORGANIZATION
    },
    {}
  );

  const stringValues = selectedEntities
    .map(({ provider_id }) => provider_id)
    .join(',');

  const onSave = async (selectedEntities, relevantProjects = []) => {
    let settingPayload = generatePmImportPayloadFromEntities[pmToolSensorId](
      selectedEntities,
      entityName
    );
    if (entityName === 'board') {
      // when we saving boards, we want to save also the projects those boards are linked to
      settingPayload = {
        ...settingPayload,
        projects: relevantProjects
      };
    }

    await updateSetting(SettingValues.PM_IMPORT_STRATEGY, {
      ...pmImportSetting,
      ...settingPayload
    });
    setSelectedEntities(selectedEntities);
  };

  useEffect(() => {
    const extractedEntitiesFromSetting = extractSelectedEntitiesFromFilter[
      pmToolSensorId
    ](pmImportSetting, entityName);
    setSelectedEntities(extractedEntitiesFromSetting);
  }, [entityName, pmImportSetting]);

  return {
    values: selectedEntities,
    stringValues,
    onSave
  };
};

export default usePmImportStrategyEntity;
